import Transition from '@ember/routing/-private/transition';
import Route from 'cio/routes/base';
import ImportModel from 'cio/models/import';
import SetupController from './controller';

export default class ImportSetupRoute extends Route {
  queryParams = {
    previousRouteName: {
      replace: true,
    },
    type: {
      refreshModel: false,
    },
    objectTypeId: {
      refreshModel: false,
    },
  };

  setupController(controller: SetupController, model: ImportModel, transition: Transition) {
    super.setupController(controller, model, transition);

    let { previousRouteName, objectTypeId } = this.paramsFor('imports.import.setup') as any;

    if (previousRouteName == null) {
      if (model.type === 'segment') {
        previousRouteName = 'segments.segment.overview.index';
      } else if (model.type === 'object') {
        previousRouteName = 'objects.type';
      } else {
        previousRouteName = 'people';
      }
    }

    controller._previousRouteName = previousRouteName;
    controller.objectTypeId = objectTypeId;
    controller.previousRouteName = null;
  }
}
